<template>
   <div class="grid mt-1 fornitori"> 
     <Loader v-if="loader" />  

     <div class="col-12 md:col-8">
      <Dropdown  
          v-model="selectedFornitore" 
          :options="fornitori"            
          :filter="true" 
          :filterFields="['ragsoc','piva','codfis']" 
          placeholder="Seleziona un fornitore" 
          class="inputfield w-full"
          @change="onChange"
        >
          <template #value="{value, placeholder}">
              <div class="client-item client-item-value" v-if="value">
                  <div>{{value.ragsoc}}</div>
              </div>
              <span v-else>
                  {{placeholder}}
              </span>
          </template>
          <template #option="slotProps">
              <div class="client-item">
                  <div>{{slotProps.option.ragsoc}} - <small>{{(slotProps.option.piva) ? slotProps.option.piva : slotProps.option.codfis}}</small></div>
              </div>
          </template>
        </Dropdown>
     </div>
     <div class="col-12 md:col-4">
      <div class="flex align-items-center justify-content-left pl-3">
        <div class="field-checkbox mb-3">
            <Checkbox id="auto" v-model="autoriempimento" :binary="true" @change="getAutoRiempimento" />
            <label for="auto">Autoriempimento
              <div class="text-500 text-xs mt-1 line-height-2">
                Se flaggato selezionerà automaticamente le fatture fino a raggiungere il totale del movimento
              </div>
            </label>
        </div>
      </div>      
     </div>    
      

      <div class="col-12">

        <div v-if="selectedFornitore && saldo_totale != null" class="col-12">

          <div v-if="fattureDaSaldare.length > 0" class="mt-3">

            <Accordion  class="my-4">
              <AccordionTab v-if="dateScadenze.length > 0" header="Date">
                <small class="m-2">Seleziona una data scadenza:</small>
                <div class="wrap-box-date">
                  <div  v-if="dateScadenze.length > 1" class="box-date" :class="{'box-date-active': selectedDataScadenza == '' || !selectedDataScadenza}" @click="injectAll">
                    Tutte <i class="pi pi-list"></i>
                  </div>
                  <div v-for="data of dateScadenze" :key="data" class="box-date" @click="filterDate(data)" :class="{ 'box-date-active' : selectedDataScadenza == data }">
                    {{formatDate(data)}}
                  </div>
                  <div  v-if="dateScadenze.length > 1" class="box-date btn-date" @click="autoSearchDate">
                    Auto ricerca data <i class="pi pi-directions"></i>
                  </div>
                </div>
                <div class="wrap-btn">
                  <div v-if="selectedDataScadenza" @click="compareDialog = true" class="btn-util text-primary text-right"> <small>Numero fatture non corrispondenti?</small> </div>
                  <div v-if="selectedDataScadenza" @click="resetFilterDate" class="btn-util p-error text-right"> <small>Reset date</small> </div>
                </div>   
              </AccordionTab>
            </Accordion>

            <DataTable dataKey="numero" ref="dt" :value="fattureDaSaldare" responsiveLayout="scroll" v-model:selection="selectedFatture" scrollHeight="400px" :scrollable="true" 
            @row-select-all="onChangeAnyRows($event, true)" @row-unselect-all="onChangeAnyRows" @row-select="onChangeAnyRows" @row-unselect="onChangeAnyRows">
              <template #header>
                <div class="flex justify-content-between flex-wrap">
                    <div>
                      <Button v-show="selectedFatture.length > 0" icon="pi pi-times" iconPos="right" label="Deseleziona tutto" @click="deselectAll()" class="deselect-all" />
                      <Button icon="pi pi-check" iconPos="right" label="Seleziona tutto" @click="selectAll()" class="select-all" />
                    </div>
                    <i></i>
                    <div>
                      <Button icon="pi pi-external-link" iconPos="right" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                    </div>
                </div>
              </template>
                <Column selectionMode="multiple" />
                <Column field="numero" header="Numero"></Column>
                <Column field="data_emissione" header="Data Emissione">
                  <template #body="{data}">
                      {{formatDate(data.data_emissione)}}
                  </template>
                </Column>
                <Column field="data_scadenza" header="Data Scadenza">
                  <template #body="{data}">
                      {{formatDate(data.data_scadenza)}}
                  </template>
                </Column>
                <Column  field="saldo" header="Saldo">
                  <template #body="{data}">
                      <p class="p-error">
                        {{data.saldo.toFixed(2)}}
                      </p> 
                  </template>
                </Column>
                <Column  field="pagato" header="Pagato">
                  <template #body="{data}">
                      {{data.pagato.toFixed(2)}}
                  </template>
                </Column>
                <Column  field="totale" header="Totale Fattura">
                  <template #body="{data}">
                      {{data.totale.toFixed(2)}}
                  </template>
                </Column>
                <Column field="modified" header="Modificato">
                  <template #body="{data}">
                    <small v-if="data.modified" @click="resetSaldo(data)" class="p-error p-reset"> Ripristina </small>
                  </template>
                </Column>
            </DataTable>

            <div class="report mt-2 mb-5">
              <small class="total"> Elementi selezionati: {{selectedFatture.length}} / {{fattureDaSaldare.length}}</small>
              <small class="total">Saldo totale: {{saldo_totale}} €</small>
            </div>

            <div class="chip-selected-suggest mt-3 p-fluid">
              <Chips v-model="selectedFatture" @keypress.prevent="false" @remove="removeChip()">
                <template #chip="slotProps">
                    <div v-if="slotProps.value.real" @click="openEditSaldoDialog(slotProps.value)" class="chip-basic">
                        <div class="title-chip">{{slotProps.value.numero}}</div>
                        <span style="font-size: 12px">€ {{slotProps.value.saldo_modificato.toFixed(2)}}</span>
                        <i  class="icon-edit-saldo pi pi-pencil ml-2" style="font-size: 10px"></i>
                    </div>
                    <div v-else class="chip-special">
                        <div class="title-chip">{{slotProps.value.numero}}</div>
                        <span style="font-size: 12px">€ {{slotProps.value.saldo_modificato.toFixed(2)}}</span>
                        <span class="compensation"><i class="pi pi-clone"></i></span>
                    </div>
                </template>   
              </Chips>
            </div>

            <div class="my-2 md:mt-0 flex align-items-center">
              <div class="surface-300 border-round overflow-hidden w-full  mt-1" style="height:5px">
                <div 
                class="p-bar h-full" 
                :style="{ width: percentage +'%'}"
                :class="(percentage == 100) ? 'bg-blue-500' : (percentage > 100) ? 'bg-red-500': 'bg-yellow-500'"
                >
                </div>
              </div>
            </div>

            <div class="grid">
              <div class="col-4 flex justify-content-start">
                <div class="text-left">
                  <p class="title-bar">ASSOCIATO</p>
                  <b  class="num-bar text-yellow-500">{{selectedSum.toFixed(2)}}</b>
                </div>
              </div>
              <div class="col-4 flex justify-content-center">
                <div class="text-left">
                  <p class="title-bar">RIMANENTI</p>
                  <b class="num-bar p-error">{{( Math.abs(estrattoConto.value) - Math.abs(selectedSum)).toFixed(2)}}</b>
                </div>
              </div>
              <div class="col-4 flex justify-content-end">
                <div class="text-left">
                  <p class="title-bar">TOTALE</p>
                  <b class="num-bar text-blue-500">{{estrattoConto.value.toFixed(2)}} </b> &euro;
                </div>
              </div>
            </div> 

            <div class="mt-3 text-right">
                <Button 
                @click="associa" 
                label="Associa movimento" 
                class="p-button-outlined" 
                :disabled="Math.abs(selectedSum.toFixed(2)) != Math.abs(estrattoConto.value.toFixed(2))" 
                :class="Math.abs(selectedSum.toFixed(2)) != Math.abs(estrattoConto.value.toFixed(2)) ? 'p-button-secondary' : ' p-button-primary'" 
                />
            </div>

          </div>
          <div v-else>
            <p class="text-center">Nessuna fattura da mostrare</p>
          </div>
                 
        </div>
      </div>
   </div>

   <!-- DIALOG EDIT SALDO CHIP -->
    <Dialog v-model:visible="editSaldoDialog" :style="{width: '450px'}" header="Modifica" :modal="true">
        <div class="confirmation-content">
            <div v-if="estrattoConto">Inserisci l'importo <br>
              <InputText type="text" v-model="temp.saldo_modificato" class="inputfield w-full mt-2" :class="{'p-invalid': validationErrors.saldo && submitted }" />
              <small class="p-error" v-if="validationErrors.saldo && submitted">Valore non valido (totale dei selezionati supera l'importo del movimento)</small>
            </div> 
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="editSaldoDialog = false"/>
            <Button label="Modifica" icon="pi pi-check" class="p-button-text" @click="editSaldo" />
        </template>
    </Dialog>


    <!-- DIALOG COMPARE N. FATTURE -->
    <Dialog v-model:visible="compareDialog" :style="{width: '75vw'}" header="Inserisci numeri fatture" :modal="true">
        <div class="confirmation-content">
           <div v-show="validationErrors.empty_numbers && submitted" class="p-error">Inserisci numeri fattura.</div>
            <Textarea v-model="numbers_insert" rows="5" :style="{width: '100%'}" placeholder="30008200,40000009 ..." />
        </div>
        <div v-if="fattureDiffernce.length > 0">
          <h6 class="my-2">Non trovate:</h6>
          <div class="p-error">{{fattureDiffernce.join(', ')}}</div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="compareDialog = false"/>
            <Button label="Confronta" icon="pi pi-check" class="p-button-text" @click="compareNumeriFatture" />
        </template>
    </Dialog>


</template>

<script>

import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  emits:['movement-regularized'],
  components: {
    Loader
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const loader = ref(false)
    const toast = useToast();
    const dt = ref();
    const autoriempimento = ref(false);
    const estrattoConto = ref(props.detail)
    const selectedFornitore = ref()
    const fornitori = ref([])
    const saldo_totale = ref(null)
    const fattureDaSaldare = ref([])
    const fattureDaSaldareOriginal = ref([])
    const fattureRemoved = ref([])
    const dateScadenze = ref([])
    const selectedDateScadenze = ref([])
    const selectedDataScadenza = ref()
    const selectedFatture = ref([])
    const editSaldoDialog = ref(false)
    const compareDialog = ref(false)
    const numbers_insert = ref('')
    const fattureDiffernce = ref([])
    const temp = ref(null)
    const submitted = ref(false);
    const validationErrors = ref({})

    onMounted(() => {
      getData()
    })

    const getData = () => {
      selectedDataScadenza.value = ''
      loader.value = true
      service.getFornitori().then((res) => {
        fornitori.value = res.items
      }).finally(() => {
        loader.value = false
      }) 
    }
    const onChange = () => {
      saldo_totale.value = null
      loader.value = true
      fattureDaSaldare.value = []
      if (selectedFornitore.value.id != null) {
            service.getFattureDaSaldareFornitore(selectedFornitore.value.id).then((res) => {
              if (res.items.length > 0) {
                 const response = res.items.map((el) =>{
                  el.modified = false
                  el.real = true
                  el.saldo_modificato = el.saldo
                  return el
                })
                fattureDaSaldare.value = response
                fattureDaSaldareOriginal.value = response
                
                // if (estrattoConto.value.value > 0) {
                //   fattureDaSaldare.value = response.filter((el) => el.saldo > 0)
                //   fattureRemoved.value = response.filter((el) => el.saldo < 0)
                // } else {
                //   fattureDaSaldare.value = response.filter((el) => el.saldo < 0)
                //   fattureRemoved.value = response.filter((el) => el.saldo > 0)
                // }
                saldo_totale.value = (fattureDaSaldare.value.reduce((prev, curr) => prev + curr.saldo, 0)).toFixed(2)
                
                getAutoRiempimento()
                addVirtualFattura()
              } else {
                saldo_totale.value = 0
              } 
            }).finally(() => {
              loader.value = false
              dateScadenze.value = []
              fattureDaSaldare.value.forEach(el => {
                if (!dateScadenze.value.includes(el.data_scadenza)) {
                  dateScadenze.value.push(el.data_scadenza)
                }                 
              });
            })
      }
    }

    const selectAll = () => {
      if (selectedDataScadenza.value == '') {
          selectedFatture.value = fattureDaSaldareOriginal.value
      } else {
        //selectedFatture.value = selectedFatture.value.concat(fattureDaSaldareOriginal.value.filter((el) => el.data_scadenza == selectedDataScadenza.value))
        let array = selectedFatture.value.concat(fattureDaSaldareOriginal.value.filter((el) => el.data_scadenza == selectedDataScadenza.value))
        selectedFatture.value = [...new Set([...selectedFatture.value,...array])]
      }
      
    }

    const onChangeAnyRows = (event, unselect = null) => {
      addVirtualFattura(event, unselect)
    }

    const removeChip = () => {
      addVirtualFattura()
    }

    const getAutoRiempimento = () => {
      if (autoriempimento.value) {
        let total = 0
        let residuo = 0
        let complete = false
        selectedFatture.value = fattureDaSaldare.value.filter(el => {
          
          total += el.saldo_modificato;

          if (!complete) {
            if ( Math.abs(parseFloat(total.toFixed(2))) <=  Math.abs(estrattoConto.value.value)) {
              return el
            } else {
              total -= el.saldo_modificato
              residuo = Math.abs(estrattoConto.value.value) - total
              el.saldo_modificato = residuo
              el.modified = true
              complete = true
              return el
            }                
          }
        })
      } else {
        selectedFatture.value = []
      }
    }

    const autoSearchDate = () => {
      let found = false

      dateScadenze.value.forEach(date => {
          let total = fattureDaSaldareOriginal.value.filter((el)=> el.data_scadenza == date).reduce((acc,curr) => acc + curr.saldo_modificato, 0)
          if (Math.abs(estrattoConto.value.value) == Math.abs(total.toFixed(2))) {
            filterDate(date)
            selectedFatture.value = fattureDaSaldareOriginal.value.filter((el) => el.data_scadenza == date)
            found = true
          }
      });
      if (found) {
         toast.add({severity:'success',summary: 'Data trovata', detail:'Importi corrispondenti', life: 3000});
      } else {
        toast.add({severity:'warn',summary: 'Data non trovata', detail:'Nessuna corrispondenza', life: 3000});
      }
    }


    //create virtual fattura if movimeto > saldo_totale
    const addVirtualFattura = (event, unselect) => {
      if (Math.abs(estrattoConto.value.value) > Math.abs(saldo_totale.value)) {
        selectedFatture.value = selectedFatture.value.filter((el) => el.real == true)
        if (unselect) {
          selectedFatture.value = []
          selectedFatture.value = fattureDaSaldare.value
        } 
        let val = (estrattoConto.value.value - selectedSum.value)
        let virtualFattura = {...selectedFatture.value[selectedFatture.value.length -1]}
        virtualFattura.saldo_modificato = val
        virtualFattura.real = false
        if (selectedFatture.value.length > 0) {
          selectedFatture.value.push(virtualFattura)
        } else {
          selectedFatture.value = []
        }
        fattureDaSaldare.value = fattureDaSaldare.value.filter((el) => el.real == true)
      }   
    }

    const filterDate = (date) => {
      selectedDataScadenza.value = ''
      selectedDataScadenza.value = date
      // selectedFatture.value = []
      fattureDaSaldare.value = fattureDaSaldareOriginal.value.filter((el) => el.data_scadenza == date)
    }

    const resetFilterDate = () => {
      selectedDataScadenza.value = ''
      selectedFatture.value = []
      fattureDaSaldare.value = fattureDaSaldareOriginal.value
      resetSaldo()
    }

    const injectAll = () => {
      selectedDataScadenza.value = ''
      fattureDaSaldare.value = fattureDaSaldareOriginal.value
    }


    
    const selectedSum = computed(() => {
        return selectedFatture.value.reduce((acc, el) =>  acc +  el.saldo_modificato, 0)
    })

    const percentage = computed(() => {
        let percentage =  ((100 * selectedSum.value) / estrattoConto.value.value).toFixed(2)
        return Math.abs(percentage)
    })

    const associa = () => {
      const obj = estrattoConto.value
      obj.payments = JSON.parse(JSON.stringify(selectedFatture.value))
      
      service.associateToPayments(obj).then((res)=> {
        if (res) {
          emit('movement-regularized',{id: estrattoConto.value.id})
        }
      }) 
    }

    const compareNumeriFatture = () => {
      submitted.value = true;
      const valid = validateNumberInsert()
      if (valid) {
        fattureDiffernce.value = []
        let numbersFatture = []
        let numbersInsert = numbers_insert.value.replace(/\s/g,'').split(',');
        fattureDaSaldare.value.forEach(el => {
            numbersFatture.push(el.numero)
        });
        fattureDiffernce.value = numbersInsert.filter(x => !numbersFatture.includes(x)).concat(numbersFatture.filter(x => !numbersInsert.includes(x)));
      }  
    }

    const resetSaldo = (el = null) => {
      if (el) {
        el.saldo_modificato =  el.saldo
        el.modified = false
      } else {
        fattureDaSaldare.value.map(el => {
            el.saldo_modificato =  el.saldo
            el.modified = false
        });
      }
      addVirtualFattura()
    }

    const openEditSaldoDialog = (el) => {
      submitted.value = false;
      temp.value = null
      temp.value = {...el}
      temp.value.saldo_modificato = temp.value.saldo_modificato.toFixed(2)
      editSaldoDialog.value = true
    }

    const editSaldo = () => {
      submitted.value = true;
      temp.value.saldo_modificato = temp.value.saldo_modificato.toString()
      temp.value.saldo_modificato = temp.value.saldo_modificato.replaceAll(',','.')
      temp.value.saldo_modificato = parseFloat(temp.value.saldo_modificato)
      //temp.value.saldo_modificato = estrattoConto.value.value < 0 ? Math.abs(temp.value.saldo_modificato) * -1 : Math.abs(temp.value.saldo_modificato)
      
      selectedFatture.value = selectedFatture.value.filter(el => {
        if (el.numero == temp.value.numero && el.real == true) {
          let saldo_temp = el.saldo_modificato
          el.saldo_modificato = temp.value.saldo_modificato
          const valid = verifyIsValid()
          if (valid) {
            el.modified = true
            editSaldoDialog.value = false
            return el
          } else {
            el.saldo_modificato = saldo_temp
            return el
          }
        } else {
          return el
        }
      })
      addVirtualFattura()
    }

    const verifyIsValid = () => {
      validationErrors.value = [];
      if(parseFloat(Math.abs(selectedSum.value).toFixed(2)) > parseFloat(Math.abs(estrattoConto.value.value).toFixed(2))) {
        validationErrors.value['saldo'] = true;
        return false
      } else {
        delete validationErrors.value['saldo'];
        return true
      }
    }

    const validateNumberInsert = () =>{
      validationErrors.value = [];
      if (numbers_insert.value.replace(/\s/g,'') != '')
        delete validationErrors.value['empty_numbers'];
      else 
        validationErrors.value['empty_numbers'] = true;
  
      return !Object.keys(validationErrors.value).length;
    }

    const deselectAll = () => {
      selectedFatture.value = []
    };

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    return {
      dt,
      estrattoConto,
      selectedFornitore,
      fornitori,
      autoriempimento,
      getAutoRiempimento,
      onChange,
      removeChip,
      saldo_totale,
      fattureDaSaldare,
      fattureDaSaldareOriginal,
      selectedFatture,
      percentage,
      selectedSum,
      associa,
      editSaldoDialog,
      openEditSaldoDialog,
      compareDialog,
      numbers_insert,
      compareNumeriFatture,
      fattureDiffernce,
      temp,
      validationErrors, 
      submitted,
      editSaldo,
      resetSaldo,
      onChangeAnyRows,
      fattureRemoved,
      dateScadenze,
      selectedDateScadenze,
      selectedDataScadenza,
      filterDate,
      resetFilterDate,
      loader,
      formatDate,
      autoSearchDate,
      exportCSV,
      deselectAll,
      selectAll,
      injectAll
    }
  },
}
</script>
<style>
.fornitori .p-column-header-content .p-checkbox {
  display: none !important;
}
</style>
<style scoped>
.wrapper-saldo-totale {
  background-color: #e3f2fd;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
}
.chip-selected-suggest {
  overflow-y: scroll;
  max-height: 400px;
}
.chip-selected-suggest .p-chips-token .compensation {
  position: absolute;
  top: -2px;
  right: -4px;
  font-size: 9px;
  background: white;
  padding: 2px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chip-selected-suggest .p-chips-token .compensation i{
  font-size: 10px;
  color: black;
}
.wrapper-info-movement {
  background-color: rgba(253, 174, 174, 0.616);
  border-radius: 8px;
}
.wrapper-info-movement i{
 color: white;
 font-size: 20px;
}

.fornitori .report{
  margin: 10px 2px;
  display: flex;
  justify-content: right;
}
.fornitori .report .total{
  background-color: #e3f2fd;
  padding: 6px 10px;
  margin: 2px 8px;
  border-radius: 4px;
}
.wrap-box-date {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
.box-date {
  color: rgb(13, 175, 250);
  cursor: pointer;
  font-size: 12px;
  border: 1px solid #00000010;
  padding: 5px 8px;
  margin: 6px 3px;
  border-radius: 3px;
  background-color: #e4e4e455;
}
.box-date-active {
  background-color: rgb(29, 127, 240);
  color: white;
}

.btn-date {
  background-color: rgb(29, 127, 240);
  color: white;
}
.wrap-btn {
  display: flex;
  justify-content: right;
  align-items: center;
}
.wrap-btn .btn-util {
  cursor: pointer;
  padding: 8px;
  margin: 5px;
}
.fornitori .deselect-all {
  border: 1px solid #ff6c6c;
  background-color: #f8f9fa;
  color: red;
}

.fornitori .select-all {
  border: 1px solid #23a300;
  background-color: #f8f9fa;
  color: #23a300;
  margin-left: 4px;
}

</style>
